<template>
  <div class="full">
    <CoverFilterSummary v-model="filters"></CoverFilterSummary>
    <v-data-table  :headers="archivedHeaders" :pagination.sync="pagination"
         :rows-per-page-items="pagination.rowsPerPageItems"
         :loading="loading"
         :total-items="pagination.totalItems"
         :items="covers" class="elevation-1" >
        <template slot="headers" slot-scope="props">
              <tr>
               <template v-for="header in props.headers">
                  <th  v-if="extendedMode || columnsAlwaysShown.includes(header.value)" :key="$t(header.text)"  :class="$t(header.text).toUpperCase() === 'Action'.toUpperCase()?'text-xs-center' :'text-xs-left'">
                     {{ $t(header.text) }}
                   </th>
               </template>
              </tr>
        </template>
        <template v-slot:items="props">
          <tr @click="showCoverDetail(props.item.id)" v-bind:class="selectedRow === props.item.id ?'selectedrow' : ''">
            <td class="text-xs-left"></td>
            <td class="text-xs-left">{{ props.item.seller.name }}<br/> <span class="smalltext greytext"> {{ props.item.seller.identifierType }} {{ props.item.seller.identifierValue }} </span></td>
            <td class="text-xs-left">{{ props.item.buyer.name }}<br/><span class="smalltext greytext">{{ props.item.buyer.identifierType }} {{ props.item.buyer.identifierValue }}</span> </td>
            <td v-if="extendedMode" class="text-xs-left">{{ $formatDate(props.item.issuedAt) }}</td>
            <td class="text-xs-left">{{ $formatDate(props.item.dueAt) }} </td>
            <td v-if="extendedMode" class="text-xs-left">{{ props.item.amount}}</td>
            <td v-if="extendedMode" class="text-xs-left">{{ props.item.number }}</td>
            <td v-if="extendedMode" class="text-xs-left"><span v-bind:class="props.item.statusCode.toLowerCase()"><p class="centerText">{{ props.item.status}}</p> </span></td>
            <td v-if="extendedMode" class="text-xs-center">
              <span>
                <v-btn @click.stop v-if="canSettleCover && isArchivedSettleableStatus(props.item.statusCode)" color="primary" small @click="settleCover(props.item.id)">{{$t('Cover.ListCover.SETTLE_COVER_BTN')}}</v-btn>
              </span>
            </td>
          </tr>
        </template>
        <template slot="no-data">
              <div v-if="loading" class="text-xs-center">
                    <v-progress-circular indeterminate  color="primary"></v-progress-circular>
              </div>
              <div v-else>
                  <p class="centerText"> {{$t('Cover.ListCover.NO_DATA_AVAILABLE_DESC')}} </p>
              </div>
        </template>
      </v-data-table>
      </div>
</template>

<script>
import coverApi from '@/services/CoverApi'
import { mapState } from 'vuex'
import constants from '@/constants/index'
import transactorApi from '@/services/TransactorApi'
import CoverFilterSummary from '@/components/common/CoverFilterSummary.vue'

export default {
  components: { CoverFilterSummary },
  data () {
    return {
      selectedRow: '',
      columnsAlwaysShown: ['first', 'seller', 'buyer', 'duedate'],
      covers: [],
      loading: true,
      paginationData: {
        descending: true,
        page: 1,
        rowsPerPage: 5,
        sortBy: 'id',
        totalItems: 0,
        rowsPerPageItems: [5]
      },
      emptyCompany: {
        id: '',
        name: '',
        identifierType: '',
        identifierValue: ''
      }
    }
  },
  watch: {
    pagination: {
      async handler () {
        this.loading = true
        await this.searchCovers(this.filters.identifierValue, this.filters.identifierTypeCode, this.filters.identifierCountryCode, this.filters.coverId)
      }
    },
    filters: {
      async handler () {
        this.loading = true
        await this.searchCovers(this.filters.identifierValue, this.filters.identifierTypeCode, this.filters.identifierCountryCode, this.filters.coverId)
      }
    },
    deep: true
  },
  methods: {
    async searchCovers (identifierValue, identifierTypeCode, identifierCountryCode, coverId) {
      let transactorId = !!identifierValue && identifierValue.length > 0 ? await transactorApi.fetchCompanyByExternalId(identifierCountryCode, identifierTypeCode, identifierValue) : undefined
      let companyId = !!transactorId && transactorId.length > 0 ? transactorId : undefined
      if (!this.$isEmpty(identifierValue) && this.$isEmpty(companyId)) {
        this.covers = []
        this.loading = false
        return
      }
      let response = await coverApi.fetchCoversbyStatusPerPage(this.paginationData.page, this.paginationData.rowsPerPage, 'TimeBarred,Rejected,Refused,Revoked', 'quotedAt', null, null, 'quotedAt', 'desc', companyId, coverId)
      if (response.items.length === 0) {
        this.loading = false
        return
      }

      this.covers = response.items.map((item) => {
        return {
          id: item.id,
          sellerId: item.sellerId,
          buyerId: item.buyerId,
          issuedAt: item.invoice.issuedAt,
          dueAt: item.invoice.dueAt,
          amount: item.invoice.amount + ' ' + item.invoice.currency.toUpperCase(),
          currency: item.invoice.currency.toUpperCase(),
          number: item.invoice.number,
          status: this.coverStatus.findIndex(x => x.name === item.status) >= 0 ? this.coverStatus.find(x => x.name === item.status).label : this.$toTitleCase(item.status),
          statusCode: item.status,
          seller: this.emptyCompany,
          buyer: this.emptyCompany
        }
      })
      this.paginationData.totalItems = response.totalCount
      let sellerIds = this.covers.map((item) => { return item.sellerId })
      let buyerIds = this.covers.map((item) => { return item.buyerId })
      let companyIds = [...new Set(sellerIds.concat(buyerIds))]
      let companies = await this.getCompanies(companyIds)

      this.covers.forEach(function (cover) {
        cover.seller = companies.find(function (company) {
          return company.id === cover.sellerId
        })

        cover.buyer = companies.find(function (company) {
          return company.id === cover.buyerId
        })
      })
      this.loading = false
    },
    async showCoverDetail (coverid) {
      this.selectedRow = coverid
      this.$parent.setHeightForSideInfo()
      this.$store.dispatch('cover/setExtendedMode', false)
      await this.$parent.showCoverInfoDetail(coverid, false, 'Archived', false)
    },
    async getCompanies (companies) {
      let resultcompanies = await coverApi.fetchCompaniesId(companies)
      return resultcompanies.items.map((item) => {
        return {
          id: item.id,
          name: item.name,
          ehId: item.ehId,
          identifierType: item.identifierType,
          identifierValue: item.identifierValue
        }
      })
    },
    async settleCover (coverid) {
      let success = await this.$parent.settleCover(coverid)
      if (success) {
        await this.getCovers()
      }
    },
    isArchivedSettleableStatus (statusCode) {
      return statusCode === constants.CoverStatus.TIMEBARRED
    }
  },
  computed: {
    pagination: {
      get: function () {
        return this.paginationData
      },
      set: function (value) {
        this.paginationData = value
      }
    },
    items () {
      return this.covers
    },
    canSettleCover: function () {
      return this.$parent.hasCoverageAccess()
    },
    ...mapState('cover', ['extendedMode', 'archivedHeaders', 'coverStatus']),
    ...mapState('userdetails', ['userInfos']),
    ...mapState('listcovertabs', ['filters'])
  }
}
</script>
